import React, { Component } from "react";
import { ResetPassword } from "../../Model/Users";
import { withRouter,importAll } from "../../Helpers/Common";
import { Link } from "react-router-dom";

/*-------------Importing Images --------------*/

var ImageData = "";
var SVGIcon = "";
const images = importAll(require.context('../../img', false, /\.(png|jpe?g|svg)$/));
const Icons = importAll(require.context('../../img/svg', false, /\.(png|jpe?g|svg)$/));
images.then(result =>ImageData = result)
Icons.then(resultData =>SVGIcon = resultData)


class Passwordreset extends Component {

  constructor(props) {
    super(props);
    this.state = {
    	EnterPasswordFields:{Password1:"",Password2:""},
    	isValidPassword1:"",
    	isValidPassword2:"",
    	ResetpasswordBtn : false,
      ResetpasswordSuccessMsg:false,
      ResetPasswordErrorMsg:false,
      showpassword1:false,
      showpassword2:false
    }

    this.Eventhandler = this.Eventhandler.bind(this);
    this.submitResetPasswordFrm = this.submitResetPasswordFrm.bind(this);
  }

  /*-----Close Window------*/
  closebtn(){
     this.props.navigate('/createaccount'); 
    //this.setState({ResetpasswordSuccessMsg:false})
  }

  /*---------Submit Reset Password ------------*/
  
  submitResetPasswordFrm(e){
      
      e.preventDefault();
      var AllState = this.props.data.state;
      var postData = {
          "email":AllState.fields.fld_email,
          "mobile":AllState.fields.fld_mobile, 
          "password":this.state.EnterPasswordFields.Password1,
          "countryCode":AllState.fields.country_code
      }

      ResetPassword(postData).then((data) => {
        var ResetPasswordResp = JSON.parse(data.data);
        if(ResetPasswordResp.success){
          this.setState({ResetpasswordSuccessMsg:true})
        }else{
          this.setState({ResetPasswordErrorMsg:true})
        }
    })
  }

  Showpassword1(){
    var checkcurrentState = this.state.showpassword1;
    if(checkcurrentState){
        this.setState({
        showpassword1:false
      })
    }else{
        this.setState({
        showpassword1:true
      })
    }
    
  }
  Showpassword2(){
    var checkcurrentState = this.state.showpassword2;
    if(checkcurrentState){
        this.setState({
        showpassword2:false
      })
    }else{
        this.setState({
        showpassword2:true
      })
    }
    
  }

  Eventhandler(e){
  
  	const fields = this.state.EnterPasswordFields;
    var Valuespost = e.target.name;
    
    if (e.target.name == "fld_password1"){

    	fields['Password1'] = e.target.value; 
    	if(e.target.value.length >= 6){
    		this.setState({
    			isValidPassword1:true,
    			fields
    		})
    	}else{
    		this.setState({
    			isValidPassword1:false,
    			fields,
    			ResetpasswordBtn:false,
    		})
    	}
    }

    if(e.target.name == "fld_password2"){

    	fields['Password2'] = e.target.value;
    	if(e.target.value.length >= 6){
    		
    		this.setState({
    			fields
    		})
    	}else{
    		this.setState({
    			isValidPassword2:false,
    			ResetpasswordBtn:false,
    			fields
    		})
    	}
    }

    var Fields = this.state.EnterPasswordFields;

    if(Fields.Password1.length >= 6 && Fields.Password2.length >= 6  && Fields.Password1 == Fields.Password2){

    	this.setState({ResetpasswordBtn:true,isValidPassword2:true})
    }else{
      this.setState({ResetpasswordBtn:false,isValidPassword2:false})

    }
  }

  render() {
    
    return (

      <>
  <div className="temp4">
    <hr className="border-red" />
    <hr className="border-red" />
    <div className="temp4-InnerRound50">
      <div className="temp4-InnerRound1">
        <div className="temp4-InnerRound2" />
      </div>
    </div>
    <div className="temp4-InnerRound51">
      <div className="temp4-InnerRound1">
        <div className="temp4-InnerRound2" />
      </div>
    </div>
    <div className="temp4-InnerRound52">
      <div className="temp4-InnerRound1">
        <div className="temp4-InnerRound2" />
      </div>
    </div>
  </div>
  <header>
    <div className="mainNav">
      <div onClick={() => {this.props.data.CustomeBackButton1();}} className="docubayBack white pl-8">
        <img src={SVGIcon['back.svg']} alt="DocuBay" /> Reset password
      </div>
      <div className="topQuestion">
        {/*<img src={SVGIcon['help.svg']} alt="help" />*/}
      </div>
    </div>
  </header>
  <main>
    <section className="mb-0">
      <div className="homeBanner">
        <div className="innerBanner mb-0">
          <div className="title-reset">
            <h1>
              Create <span className="red">password</span>
            </h1>
            <div className="reset">
              Choose a password that is hard to guess and unique to your
              account.
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style={{ paddingBottom: 45 }}>
    <form method="post"
            name="ResetPasswordFrm"
            onSubmit={this.submitResetPasswordFrm}
            noValidate="novalidate">
      <div className="temp31">
        <div className="temp31Inner">
          <div className="formField">
            <span className="password-hidden-img" onClick={() => {
                    this.Showpassword1();
                  }}>
                        <img src={this.state.showpassword1 ? "./img/svg/password-exposed.svg":"./img/svg/password-hidden.svg"} alt="DocuBay" />
                      </span>
            <input
              type={this.state.showpassword1 ?"text":"password"}
              name="fld_password1"
              autoComplete="off"
              placeholder="Enter new password"
              className="password-hidden"
              className="password-hidden"
                  
              onChange={this.Eventhandler}

            />
            <div className="valid-msg">
              <p>
                Password must be atleast 6 characters
                {this.state.isValidPassword1? (<img src={SVGIcon['tick.svg']} alt="DocuBay" />):(null)}
              </p>
            </div>
          </div>
          <div className="formField">
          <span className="password-hidden-img" onClick={() => {
                    this.Showpassword2();
                  }}>
                        <img src={this.state.showpassword2 ? "./img/svg/password-exposed.svg":"./img/svg/password-hidden.svg"} alt="DocuBay" />
                      </span>
            <input
              type={this.state.showpassword2 ?"text":"password"}
              name="fld_password2"
              autoComplete="off"
              placeholder="Re-enter password"
              className="password-hidden"
              onChange={this.Eventhandler}
            />
            <div className="valid-msg">
              <p>
                Both the password must Match
                {this.state.isValidPassword2? (<img src={SVGIcon['tick.svg']} alt="DocuBay" />):(null)}
              </p>
            </div>
          </div>
          <div className="formField mt-24 mb-24">
            <a href="#" className="temp31-modal-toggle">
              
              <button type="submit"
               id="sendEnquiryBtn"  
               
               className={
                    this.state.ResetpasswordBtn ? "btn-red" : "btn-black"
               }
               disabled={this.state.ResetpasswordBtn ? false :true}
               >
               
                Reset password
              </button>
            </a>
          </div>
        </div>
      </div>
    </form>  
    </section>
  </main>

  <div className="passChangepopup"
   style ={{display: this.state.ResetpasswordSuccessMsg ? 'flex' : 'none' }}
   id="passChange">
    <div className="temp31-modal-body">
      <button className="temp31-modal-close temp31-modal-toggle" onClick={()=>{this.closebtn()}}>
        <img src={SVGIcon['promocode-close.svg']} alt="DocuBay" />
      </button>
      <img src={ImageData['changePass.png']} alt="DocuBay" className="imgPass" />
      <div className="temp31-awesome">
        <h5>Password changed!</h5>
        <h6>Your password has been reset successfully</h6>
      </div>
      <Link to="/createaccount" type="submit" id="sendEnquiryBtn" className="btn-white">
        Back to Login
      </Link>
    </div>
  </div>
</>

      
    ); 
  }
}

export default withRouter(Passwordreset);
